(function (appComponents) {

	appComponents.services.ordersBase = function (Components) {

		var ordersBase = {};

		ordersBase.name = "ordersBase";


		Components.getComponentPrototype().extend(ordersBase);

		ordersBase._cart = ordersBase._getService("cartBase");
		ordersBase._b2bUnit = ordersBase._getService("b2bUnit");
		ordersBase._modals = ordersBase._getService("modals");
		ordersBase._helpers = ordersBase._getService("helpers");

		ordersBase.elements = {
			// get success () {
			// 	return $('[pc-container="modal--success"]');
			// },
		};

		ordersBase.bindings = function () {
			ordersBase._elements.page.on("click", '[pc-container="orders--card-go-to-tracking"]', function (e) {
				e.stopPropagation();
				e.preventDefault();
				var code = $(this).parent().closest('[pc-container="orders--item"]').attr("pc-value");
				ordersBase.handlers.onOrderGoToTrackingClick(code);
			});
			ordersBase._elements.page.on("click", '[pc-container="orders--add-to-cart"]', function () {
				var code = $(this).parents('[pc-container="orders--item"]').attr("pc-value");
				ordersBase.handlers.onAddItem(code);
			});
			ordersBase._elements.page.on("click", '[pc-container="orders--edit-saved-order"]', function () {
				var code = $(this).parents('[pc-container="orders--item"]').attr("pc-value");
				ordersBase.handlers.onEditSavedOrder(code);
			});
			ordersBase._elements.page.on("click", '[pc-container="orders--delete-saved-order"]', function () {
				var code = $(this).parents('[pc-container="orders--item"]').attr("pc-value");
				ordersBase.handlers.onDeleteSavedOrder(code);
			});
			ordersBase._elements.page.off("click", '[pc-container="orders--dl-pdf"]').on("click", '[pc-container="orders--dl-pdf"]', function () {
				var code = $(this).parents('[pc-container="orders--item"]').attr("pc-value");
				var orderID = ordersBase.getOrderByCode(code).code;
				ordersBase.handlers.onDownloadPdf(orderID);
			});
		};

		ordersBase.search = function (formData) {
			if (!ordersBase._role.flags.isOrdersAllowed) return $.Deferred().resolve();

			if (formData.customerIndexNo == null || formData.customerIndexNo == "") formData.customerIndexNo = ordersBase._b2bUnit.currentUnit.uid;
			return ordersBase._api.orders.search(formData).then(function (res) {
				if (res && res.status == 200) {
					ordersBase.decorateOrders(res.body.results);
					ordersBase.ordersCollection = res.body.results;
					return res.body;
				} else if (res.status == 210) {
					return res.body;
				}
			});
		};

		ordersBase.getOrderByCode = function (code) {
			var orderObject = null;

			ordersBase.ordersCollection.forEach(function (order) {
				if (order.code == code) {
					orderObject = order;
				}
			});

			if (!orderObject) {
				ordersBase.savedOrdersCollection.forEach(function (order) {
					if (order.code == code) {
						orderObject = order;
					}
				});
			}

			return orderObject;
		};

		ordersBase.showDetails = function (code, scrollToTracking) {

			// orderObject = ordersBase.getOrderByCode(stringOrObject);

			var paramsData = {
				code: code
			};
			if (scrollToTracking) {
				paramsData.scrollToTracking = 1;
			}
			var params = $.param(paramsData);
			var pageData = ordersBase._pages.orderDetails;

			ordersBase._handlers.onSwitchToPage(pageData, params);

		};

		ordersBase.getLastOrders = function (num) {

			var searchDataForLastOrders = {
				resultsPerPage: num,
				searchTerm: "",
			};
			return ordersBase.search(searchDataForLastOrders);
		};

		ordersBase.getSavedOrders = function (data) {
			return ordersBase._api.orders.getSavedOrders(data).then(function (res) {
				if (res && res.status == 200) {
					ordersBase.savedOrdersCollection = res.body.results;
					return res.body;
				} else if (res.status == 210) {
					return res.body;
				}
			});
		};

		ordersBase.decorateOrders = function (orders) {
			var classAlias = {
				created: {
					divClass: "o-logo-bg-1",
					iClass: "card-1-logo",
					listDotClass: "blue-dot"
				},
				shipped: {
					divClass: "o-logo-bg-3",
					iClass: "card-3-logo",
					listDotClass: "green-dot"
				},
				open: {
					divClass: "o-logo-bg-4",
					iClass: "card-4-logo",
					listDotClass: "blue-dot"
				},
				default: {
					divClass: "o-logo-bg-4",
					iClass: "card-4-logo",
					listDotClass: "blue-dot"
				},
				completely_processed: {
					divClass: "o-logo-bg-4",
					iClass: "card-5-logo",
					listDotClass: "blue-dot"
				},
				not_yet_processed: {
					divClass: "o-logo-bg-4",
					iClass: "card-6-logo",
					listDotClass: "blue-dot"
				},
				cancelling: {
					divClass: "o-logo-bg-4",
					iClass: "card-7-logo",
					listDotClass: "blue-dot"
				},
				rejected: {
					divClass: "o-logo-bg-4",
					iClass: "card-8-logo",
					listDotClass: "blue-dot"
				},
				partially_processed: {
					divClass: "o-logo-bg-4",
					iClass: "card-9-logo",
					listDotClass: "blue-dot"
				}
			};
			classAlias["on_hold"] = {
				divClass: "o-logo-bg-2",
				iClass: "card-2-logo",
				listDotClass: "red-dot"
			};
			orders.forEach(function (order) {
				var classes = classAlias[order.status.code.toLowerCase()];
				if (!classes) {
					classes = classAlias.default;
				}
				order._templateData = classes;
			});
		};

		ordersBase.downloadDocumentsRoutine = function (baseUrl, code) {
			var queryObject = {
				orderCode: code
			};
			var query = $.param(queryObject);
			var url = baseUrl + query;
			ordersBase._helpers.clickAnchorLink(url);
		};

		ordersBase.handlers = {
			onOrderGoToTrackingClick: function (code) {
				var scrollToTracking = true;
				ordersBase.showDetails(code, scrollToTracking);
			},
			onOrderTitleClick: function (code) {
				ordersBase.showDetails(code);
			},
			onEditSavedOrder: function (code) {
				if (ordersBase._cart.cartSize > 0) {
					ordersBase._modals.warning.show(ordersBase._messages.cartMustBeEmpty);
					return;
				}
				ordersBase._api.orders.editSavedOrder(code).then(function (res) {
					if (res && res.status == 200) {
						ordersBase._stash.cart.size = res.body.CART_SIZE;
						ordersBase._goToPage("cartOverview");
						return;
					}
				}).fail(function (e) {
					console.log(e);
				});
			},
			onDeleteSavedOrder: function (code) {
				ordersBase._api.orders.deleteSavedOrder(code).then(function (res) {
					if (res && res.status == 200) {
						ordersBase._events.dispatchEvent("savedOrderDeleted");
					}
				});
			},
			onUnitChanged: function () {
				ordersBase.shouldUpdateLastOrders = true;
			},
			onAddItem: function (code) {
				var orderObject = ordersBase.getOrderByCode(code);
				ordersBase._cart.addOrderOrQuoteByCode(orderObject.code);
			},
			onDownloadPdf: function (code) {
				var baseUrl = ordersBase._url.orders.downloadAsPdf;
				ordersBase.downloadDocumentsRoutine(baseUrl, code);
			}
		};

		ordersBase.init = function () {

			ordersBase._bindings();

			ordersBase._events.registerHandler("b2bUnitChanged", ordersBase.name, ordersBase.handlers.onUnitChanged);
		};

		return ordersBase;
	};

	window.appComponents = appComponents;

})(window.appComponents || {});